import type { SubscriptionStatus } from '../../types/salon'

export const SUBSCRIPTION_STATUS_LABELS: Record<SubscriptionStatus, string> = {
  trialing: 'Proefperiode',
  active: 'Actief',
  past_due: 'Betaling open',
  incomplete: 'Betaling bezig',
  canceled: 'Opgezegd',
  blocked: 'Geblokkeerd',
}

/** Combineert salons-cache met subscriptions.status (incomplete staat niet op salons). */
export function resolveSalonSubscriptionStatus (
  salonCache: string | null | undefined,
  subscriptionRowStatus: string | null | undefined,
): SubscriptionStatus {
  if (subscriptionRowStatus === 'incomplete') return 'incomplete'

  if (
    salonCache === 'active'
    || salonCache === 'past_due'
    || salonCache === 'canceled'
    || salonCache === 'blocked'
    || salonCache === 'trialing'
  ) {
    return salonCache
  }

  if (subscriptionRowStatus === 'active' || subscriptionRowStatus === 'past_due') {
    return subscriptionRowStatus
  }
  if (subscriptionRowStatus === 'blocked' || subscriptionRowStatus === 'canceled') {
    return subscriptionRowStatus
  }

  return 'trialing'
}

export function shouldShowCheckoutWizard (
  status: SubscriptionStatus,
  wizardGeforceerd = false,
): boolean {
  if (wizardGeforceerd) return true
  return status !== 'active'
}

export function canRetryPlatformPayment (status: SubscriptionStatus): boolean {
  return status === 'past_due' || status === 'incomplete' || status === 'blocked'
}
